import { lazy } from 'react';
import { createBrowserRouter } from 'react-router-dom';

import Loadable from 'components/Loadable';


// render - landing page
const PagesLanding = Loadable(lazy(() => import('Portfolio')));

// ==============================|| ROUTING RENDER ||============================== //

const router = createBrowserRouter(
  [
    {
      path: '/',
      element: <PagesLanding />,
     
    },
  ],
);

export default router;
